import { ResponseType } from "axios";
import { createNamedStub, emptyList } from "../demo/stubHelpers";

const endpoints = new Proxy(
  {},
  {
    get: () =>
      new Proxy(
        {},
        {
          get: () => "",
        }
      ),
  }
);

class StubConnection {
  authentication = "";
  auth_token = "";
  base_url = "";
  endpoints = endpoints as Record<string, unknown>;

  setAuthToken(_token: string) {}

  getJSON<T>(_url: string, _type?: ResponseType, _payload = {}): Promise<T> {
    return createNamedStub(emptyList() as T)();
  }

  getBlob = async (_url: string, _params?: Record<string, unknown>): Promise<Blob> =>
    new Blob();

  postJSON<T>(_endpoint: string, _type?: ResponseType, _payload = {}): Promise<T> {
    return createNamedStub({} as T)();
  }

  putJSON(_url: string, _type?: ResponseType, _payload = {}): Promise<unknown> {
    return createNamedStub({})();
  }

  patchJSON(_url: string, _type?: ResponseType, _payload = {}): Promise<unknown> {
    return createNamedStub({})();
  }

  deleteJSON(_url: string, _type?: ResponseType, _payload = {}) {
    return createNamedStub({})();
  }
}

export type IConnections = Record<string, unknown>;

export const getOtherConnectionUrl = (_service: string): string => "";

export const conn = new StubConnection();

export default StubConnection;
